export const CONTENT_TYPE_KEY = 'Content-Type';
export const CONTENT_TYPE_VALUE = {
    default: 'application/json',
    formData: 'multipart/form-data',
    urlEncoded: 'application/x-www-form-urlencoded',
};
